

























import {
  Component,
  Emit,
  Vue
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { CART } from '@/store/types';
import { EssentialProductFilter } from '@eurogast/hub-client-typescript';
import { ConfigService } from '@/services/ConfigService';

const cart = namespace(CART);

@Component({
  components: {}
})
export default class AutoCompleteHeader extends Vue {

  get isLoggedIn(): boolean {
    return ConfigService.isLoggedIn();
  }

  public emitFormIgnoreEssentials() {
    this.submitForm(EssentialProductFilter.IGNORE);
  }

  public emitFormEssentialProductFilterOnly() {
    this.submitForm(EssentialProductFilter.SHOWNONLY);
  }

  @Emit()
  public submitForm(withEssentialProductFilter: EssentialProductFilter) {
    return withEssentialProductFilter;
  }

  @Emit() // intentionally empty because we only need the event-trigger and no additional info
  public closeSearchResults() {}

}
